import { configureContext } from '@tools/wr-catalog-base'
import routes from '@routes/routes'
import config from './config'
import * as actions from './actions'

export const initStore = () =>
  configureContext({
    ...config,
    state: {
      ...config.state,
      productsRows: {},
      cartCalculations: {
        totalPrice: 0,
        discount: 0,
      },
      cartForm: null,
      selectedDocumentsIds: [],
    },
    actions: {
      ...actions,
    },
    routes,
  })
